// MARK://dhk8/pos/stores/lock-store
// Terminal-lock state, kept *separate* from auth-store on purpose: locking the
// terminal must not touch the session token. Persists to sessionStorage so a tab
// reload while locked stays locked (mirrors @dockethub/ui-restaurant's lockSession()).
//
// Unlock semantics (PIN re-entry) live in features/shell/LockOverlay.tsx — it calls
// dhk8-platform-auth's POST /v1/auth/pin-unlock with the PIN. If the PIN belongs to a
// different cashier of the same branch the backend swaps the operator; here we just
// flip `locked` once the call resolves.

import { create } from 'zustand'
import { lockSession, isSessionLocked } from '@dockethub/ui-restaurant'

interface LockState {
  locked: boolean
  /** Lock the terminal (also persists to sessionStorage). */
  lock: () => void
  /** Unlock the terminal (clears the persisted flag — done by LockOverlay after PIN ok). */
  unlock: () => void
}

export const useLockStore = create<LockState>((set) => ({
  locked: isSessionLocked(),
  lock: () => {
    lockSession()
    set({ locked: true })
  },
  unlock: () => {
    // LockScreen (ui-restaurant) clears the storage key itself on a successful onUnlock,
    // but clear here too in case unlock() is called from elsewhere (e.g. a test).
    try { sessionStorage.removeItem('dhk8.lock') } catch { /* ignore */ }
    set({ locked: false })
  },
}))
